// const list1 = [{
//     id: 1,
//     className: 'flex-1',
//     name: '体检',
//     label: 2398
// }, {
//     id: 2,
//     className: 'flex-1',
//     name: '降血脂',
//     label: 3784
// }, {
//     id: 3,
//     className: 'flex-1',
//     name: '降血糖',
//     label: 98341
// }];
const list3 = [{
    id: 3,
    className: 'flex-1',
    name: 'vpf',
    label: 150,
    tag: ''
}, {
    id: 4,
    className: 'flex-1',
    name: '血液四项',
    label: 100,
    tag: ''
}]

const listBaZhou = [{
    id: 3,
    className: 'flex-1',
    name: 'vpf',
    label: 150,
    tag: ''
}, {
    id: 5,
    className: 'flex-1',
    name: '肿标',
    label: 200,
    tag: ''
}]

// orgId 1160：仅 vpf，金额可自定义输入
const list1160 = [{
    id: 3,
    className: 'flex-1',
    name: 'vpf',
    label: 0,
    tag: '',
    customAmount: true
}]

const list1169 = [{
    id: 3,
    className: 'flex-1',
    name: 'vpf',
    label: 0,
    tag: '',
    customAmount: true
},{
    id: 4,
    className: 'flex-1',
    name: '四项血液',
    label: 0,
    tag: '',
    customAmount: true
}]

// orgId 1270：VPF 150元，血液四项 100元
const list1270 = [{
    id: 3,
    className: 'flex-1',
    name: 'vpf',
    label: 150,
    tag: ''
}, {
    id: 4,
    className: 'flex-1',
    name: '血液四项',
    label: 100,
    tag: ''
}]

// orgId 1234：VPF 150元，体检套餐二 530元，体检套餐六 270元，四项血液 100元
const list1234 = [{
    id: 3,
    className: 'flex-1',
    name: 'vpf',
    label: 150,
    tag: ''
}, {
    id: 8,
    className: 'flex-1',
    name: '体检套餐二',
    label: 530,
    tag: ''
}, {
    id: 16,
    className: 'flex-1',
    name: '体检套餐六',
    label: 270,
    tag: ''
}, {
    id: 4,
    className: 'flex-1',
    name: '四项血液',
    label: 100,
    tag: ''
}]

// const list2 = [{
//     id: 7,
//     className: 'flex-1',
//     name: '降血压',
//     label: 3948
// }, {
//     id: 8,
//     className: 'flex-1',
//     name: '消化系统',
//     label: 98341
// }, {
//     id: 9,
//     className: 'flex-1',
//     name: '心脏彩超',
//     label: 3948
// }];
export const list = [list3];
export const expendList = [...list3];

export const baZhou = [listBaZhou];
export const expendBaZhou = [...listBaZhou];

export const list1160Config = [list1160];
export const expend1160 = [...list1160];

export const list1169Config = [list1169];
export const expend1169 = [...list1169];

export const list1270Config = [list1270];
export const expend1270 = [...list1270];

export const list1234Config = [list1234];
export const expend1234 = [...list1234];


export const item = JSON.parse(JSON.stringify({
    personName: "", // 客户姓名
    personIdCard: "", // 客户身份证号
    personPhone: "", // 客户手机号
    checkStartTime: "", // 开始时间
    productList: [], // 产品列表
    sum: 0, // 总计
  }));